// @flow

import {
  denormalizeJsonApi,
  extractPagination
} from "buba-components/src/utils/denormalizeJsonApi";

export const mapResponseForCustomer = response => {
  const normalized = denormalizeJsonApi(response);

  return {
    inquiries: normalized.map(({ id, status, timeInformation, inquiry, company }) => ({
      processId: id,
      id: inquiry.id,
      date: new Date(inquiry.createdAt),
      bankTime: timeInformation,
      company: company?.name,
      amount: inquiry.amount,
      collaterals: inquiry.collaterals === "yes" ? "Ja" : "Nein",
      status
    })),
    pagination: extractPagination(response),
    tabCounts: {
      ...response.data.meta.count
    }
  };
};

export const mapResponseForBankAdvisor = response => {
  const normalized = denormalizeJsonApi(response);

  return {
    inquiries: normalized.map(({ id, process: { status }, company, createdAt, amount }) => ({
      id,
      date: new Date(createdAt),
      company: company?.name,
      amount,
      status
    })),
    pagination: extractPagination(response),
    tabCounts: {
      ...response.data.meta.count
    }
  };
};

export const mapResponseForBankAdvisorV2 = response => {
  const normalized = denormalizeJsonApi(response);

  return {
    inquiries: normalized.map(
      ({ id, processingStatus, company, createdAt, financingRequest: { projectAmount } }) => ({
        id,
        date: new Date(createdAt),
        company: company?.name,
        amount: projectAmount,
        status: processingStatus
      })
    ),
    pagination: extractPagination(response),
    tabCounts: {
      ...response.data.meta.count
    }
  };
};
